import "react-circular-progressbar/dist/styles.css";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import styled from "styled-components";

import {
    ArrowLeftColor
} from "@components";
import { selectMerchant } from "@redux";
import { RenderMeta } from "@utils";
import { ListWinner } from "./shared/ListWinner";


export const ComponentListOfWinner = () => {
    //page hook
    const { t } = useTranslation();
    //push route
    const history = useHistory();
    //redux statex
    const { themes } = useSelector(selectMerchant);
    const themeColor = themes?.themeColor;
    const merchant = useSelector(selectMerchant);
    return (
        <>
            <RenderMeta title={t("meta.historyredeem_page")} />
            <StyledListOfWinner themeColor={themes?.themeColor!}>
                <header>
                    <div className="back-arrow">
                        <ArrowLeftColor
                            color={themes?.themeColor}
                            onClick={() => history.goBack()}
                        />
                    </div>
                    <h4>Lists of winners</h4>
                </header>
                <div className="layout-list-winner">
                    <div className="title-text">
                        <span>Rewards</span>
                        <span>Winners</span>
                    </div>
                    <ListWinner title="Complete Birthday Profile" imgmission="../../images/img-spinbenefit-01.svg" isWinner={true} nameWiner="test winner" />
                    <ListWinner title="Complete Birthday Profile" imgmission="../../images/img-spinbenefit-01.svg" isWinner={true} nameWiner="test winner" />
                    <ListWinner title="Complete Birthday Profile" imgmission="../../images/img-spinbenefit-01.svg" isWinner={false} />
                    <ListWinner title="Complete Birthday Profile" imgmission="../../images/img-spinbenefit-01.svg" isWinner={false} />
                    <ListWinner title="Complete Birthday Profile" imgmission="../../images/img-spinbenefit-01.svg" isWinner={false} />
                    <ListWinner title="Complete Birthday Profile" imgmission="../../images/img-spinbenefit-01.svg" isWinner={false} />
                    <ListWinner title="Complete Birthday Profile" imgmission="../../images/img-spinbenefit-01.svg" isWinner={false} />
                </div>
            </StyledListOfWinner>
        </>
    );
};
const StyledListOfWinner = styled.div<{ themeColor: string }>`
    width: 100%;
    margin: 0 auto;
    padding: 15px 15px;
    height: 100vh;
    background-color: #F36249;
    position: relative;
    .logo-survey {
        font-size: 32px;
        color: ${(p) => p.themeColor};
        font-weight: 600;
    }
    .back-arrow {
        position: absolute;
        display: flex;
        align-items: center;
        top: 17px;
        span {
            margin-left: 10px;
            color: ${(p) => p.themeColor};
        }
    }
    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;
        position: relative;
        .title-group {
            text-align: center;
        }
        .text-header {
            font-size: 16px;
        }
        h4 {
            flex: 1;
            display: flex;
            justify-content: center;
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 25px;
            color: #fff;
        }
    }
    .layout-list-winner {
        background-color: #fff;
        border-radius: 16px;
        padding:16px;
        .title-text {
            display: flex;
            margin-bottom: 15px;
            justify-content: space-between;
            align-items: center;
            span {
                color: #9b9b9b;
                font-size: 12px;
                line-height: 15px;
            }
        }
    }
`;

